import coreApi from "../../lib/coreApi";

export default {
  getContactSupportRequest: (data) => {
    let qp = "";
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        qp = qp + `&${key}=${data[key]}`;
      }
    }

    if (qp && qp.length && qp.length > 1) qp = qp.replace(qp.charAt(0), "?");

    let url = `${JSON.parse(localStorage.getItem("user"))?.is_super
      ? "/backoffice"
      : JSON.parse(localStorage.getItem("user"))?.is_admin
        ? "/admin" : JSON.parse(localStorage.getItem("user"))?.is_hr
          ? "/hr"
        : ""
      }/contact/support${qp}`

    let result = coreApi.GET(url);
    return result;
  },
  createContactSupportRequest: (data) => {
    let url = `${JSON.parse(localStorage.getItem("user"))?.is_super
      ? "/backoffice"
      : JSON.parse(localStorage.getItem("user"))?.is_admin
        ? "/admin" : JSON.parse(localStorage.getItem("user"))?.is_hr
          ? "/hr"
        : ""
      }/contact/support`;

    let result = coreApi.POST(url, data);

    return result;

  },
  addContactSupportResponse: (contact_id, data) => {
    let url = `/backoffice/contact/support/${contact_id}`
    let result = ""
    if (data.hasOwnProperty("action")) {
      result = coreApi.PATCH(`${url}?action=${data?.action}`, data)
      return result;
    }
    result = coreApi.PATCH(url, data);
    return result;
  }
}